var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"DoT-one1"}),_vm._v(" "),_c('div',{staticClass:"DoT-two2"}),_vm._v(" "),_c('div',{staticClass:"Training"},[_c('p',[_vm._v(_vm._s(_vm.$route.query.pname))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2271359f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/StudyAndStudy.vue
// module id = null
// module chunks = 